// extracted by mini-css-extract-plugin
module.exports = {"container":"menu_container__DfKRS","main-menu":"menu_main-menu__37Bl4","mainMenu":"menu_main-menu__37Bl4","btn":"menu_btn__3OBdh","menu":"menu_menu__1sI9l","li-main-menu":"menu_li-main-menu__2LT3J","liMainMenu":"menu_li-main-menu__2LT3J"};
    if(module.hot) {
      // 1745908315049
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  